module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_52455461_XL-71c7b5508815bcd499f7d811936c8379.jpg";